import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input, OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";
import * as _ from "lodash";
import {PlanningViewSettingsRouteModel} from "../../../models/planning-view-settings.model";
import {PlanningRouteModel} from "../../../models/planning-route.model";

require('./planning-activity-overview-card.scss');
@Component({
  standalone: false,
  selector: 'app-planning-activity-overview-card',
  templateUrl: './planning-activity-overview-card.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningActivityOverviewCardComponent implements OnInit, OnChanges {

  @Input() activity: any;
  @Input() index: number;
  @Input() job?: any;
  @Input() route?: PlanningRouteModel;
  @Input() settings: PlanningViewSettingsRouteModel;
  @Output() onViewJob = new EventEmitter<{ jobs: any[], event?: any }>();
  @Output() onSelect = new EventEmitter();

  public stopRef?: any;
  public barcodesList: string[];
  public labels: string[];
  public routeColor: string;
  public dateRange: {notBefore: string, notAfter: string};
  public isHover: boolean;

  constructor(@Inject('planningCommonService') private planningCommonService, @Inject('$timeout') private $timeout) {}

  ngOnInit() {
    this.setRouteColor();

    if (this.job) {
      this._setJobInfo(this.job);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.job && !changes.job.isFirstChange()) {
      this._setJobInfo(this.job);
    }
  }

  onHover(isHover) {
    this.isHover = isHover;
    this.$timeout(0).then(() => {});
  }

  private setRouteColor() {
    this.routeColor = this.planningCommonService.getRouteColor(this.route);
  }

  private _setJobInfo(job) {
    this.stopRef = undefined;
    this.labels = [];
    this.barcodesList = [];

    if (job) {
      this.stopRef = _.find(job.stops, (s: any) => {
        return s.id === this.activity.stopId
      })
    }

    if (job?.packages) {
      this.barcodesList = this.job.packages.filter((p) => !!p.barcode).map((p) => p.barcode);

      this.job.packages?.forEach(p => {
        if (p.labels?.length) {
          this.labels = this.labels.concat(p.labels);
        }
      })
    }

  }

}
